/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import cTokens from '../../../../Fct/tokens/cTokens.json';
import { compoundTokens } from '../constants';
export var BorrowBalance = createPlugin({
    protocol: 'COMPOUND_V2',
    type: 'GETTER',
    method: 'borrowBalanceCurrent',
    description: 'Borrow ETH or ERC20 tokens',
    supportedContracts: cTokens,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'ctoken',
                    options: compoundTokens.filter(function (token) { return token.chainId === Number(chainId); }),
                }),
                methodParams: {
                    account: new FctAddress({}),
                },
            },
            output: {
                borrowedAmount: new FctValue({ innerIndex: 0 }),
            },
        });
    },
});
